import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { buildScene3Sequence } from './scenario2/scene3SequenceAdapter.js';
import { Scene3StepsExecutor } from './scenario2/scene3StepsExecutor.js';

// logic2Scene3: управление сценарием 2 (scene3)
// Остаётся отдельным файлом логики сценария 2, но последовательность исполняется по steps
// из scripts/scenario2/scene3SequenceAdapter.js.

export class GameLogic2Scene3 {

  constructor({ audioBaseUrl = './assets', timeScale = 1 } = {}) {
    this.audioBaseUrl = audioBaseUrl;
    this.timeScale = Number(timeScale) || 1;

    this._introStarted = false;

    this._phoneNode = null;
    this._phoneInstructionLabel = null;

    this._phoneEnabled = false;

    this._running = false;

    // Два видео-тега (одновременно)
    this._video1 = window?.gameState?.video1;
    this._video2 = window?.gameState?.video2;

    this._steps = buildScene3Sequence();
    this._executor = new Scene3StepsExecutor({
      video1: this._video1,
      video2: this._video2,
      timeScale: this.timeScale,
    });

    // waitPhoneClick support
    this._phoneClickResolver = null;
    this._phoneWaitPromise = null;

    this._bindInvestigationPlaybackBtn();

    this._bindVideoControls();
  }
  _bindVideoControls() {
    const playPauseBtn = document.getElementById('btn-playpause');
    const rewindBtn = document.getElementById('btn-rewind');
    const forwardBtn = document.getElementById('btn-forward');

    playPauseBtn?.addEventListener('click', () => {
      if (this._video1.paused) {
        this.syncPlay();
        playPauseBtn.textContent = 'Пауза';
      } else {
        this.syncPause();
        playPauseBtn.textContent = 'Играть';
      }
    });

    rewindBtn?.addEventListener('click', () => this.syncSeek(this._video1.currentTime - 3));
    forwardBtn?.addEventListener('click', () => this.syncSeek(this._video1.currentTime + 3));
  }

  syncPause() {
    if (this._video1) this._video1.pause();
    if (this._video2) this._video2.pause();
  }

  syncPlay() {
    if (this._video1) this._video1.play().catch(() => { });
    if (this._video2) this._video2.play().catch(() => { });
  }

  syncSeek(time) {
    if (!this._video1) return;
    const newTime = Math.max(0, Math.min(time, this._video1.duration));
    this._video1.currentTime = newTime;
    this._video2.currentTime = newTime;
  }
  _bindInvestigationPlaybackBtn() {
    const startBtn = document.getElementById('startInvestigationBtn');
    if (!startBtn) return;

    if (startBtn.dataset.boundScene3Playback === '1') return;
    startBtn.dataset.boundScene3Playback = '1';

    startBtn.addEventListener('click', () => {
      // По ТЗ: кнопка должна запускать _startFlow только когда на ней “НАЧАТЬ СМОТРЕТЬ ДОПРОСЫ”
      const t = (startBtn.textContent || '').toUpperCase();
      if (t.includes('СМОТРЕТЬ') && (t.includes('ДОПРОС') || t.includes('ДОПРОСЫ'))) {
        this._startFlow().catch((e) => console.error(e));
      }
    });
  }


  setPhoneNode(phoneNode) {
    this._phoneNode = phoneNode;
    if (this._phoneInstructionLabel) {
      this._phoneInstructionLabel.visible = true;
    }
  }

  _ensurePhoneLabel() {
    if (!this._phoneNode) return null;
    if (this._phoneInstructionLabel) return this._phoneInstructionLabel;

    const div = document.createElement('div');
    div.className = 'world-label';
    div.textContent = 'сделать звонок';
    div.style.color = 'white';
    div.style.background = 'rgba(0,0,0,0.75)';
    div.style.padding = '10px 14px';
    div.style.borderRadius = '12px';
    div.style.fontFamily = 'sans-serif';
    div.style.fontSize = '18px';

    const labelObj = new CSS2DObject(div);
    labelObj.position.set(-1, 0.3, 0);
    this._phoneNode.add(labelObj);

    this._phoneInstructionLabel = labelObj;
    return labelObj;
  }

  _setPhoneEnabled(enabled, labelText) {
    this._phoneEnabled = !!enabled;
    const lbl = this._ensurePhoneLabel();
    if (!lbl) return;

    if (typeof labelText === 'string' && lbl.element?.textContent != null) {
      lbl.element.textContent = labelText;
    }

    lbl.visible = true;
  }

  _hidePhoneLabel() {
    if (this._phoneInstructionLabel) {
      this._phoneInstructionLabel.visible = false;
    }
  }

  async onStartInvestigation() {
    if (this._introStarted) return;
    this._introStarted = true;

    // Скрываем кнопку сразу после старта (как требует ТЗ)
    const startBtn = document.getElementById('startInvestigationBtn');
    if (startBtn) startBtn.style.display = 'none';

    // Первый шаг steps — intro audio
    await this._startFlow();
  }

async _showDossierViewer(cards, delayMs) {
    if (!cards || cards.length === 0) return;

    const overlay = document.getElementById('dossier-overlay');
    const imgEl = document.getElementById('dossier-img');
    const prevBtn = document.getElementById('dossier-prev-btn');
    const nextBtn = document.getElementById('dossier-next-btn');

    if (!overlay || !imgEl || !prevBtn || !nextBtn) return;

    let currentIndex = 0;

    const updateCard = () => {
      imgEl.src = this._buildMediaUrl(cards[currentIndex]);
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === cards.length - 1;
    };

    updateCard();
    overlay.style.display = 'flex';

    return new Promise((resolve) => {
      let timer = null;

      const cleanup = () => {
        if (timer) clearTimeout(timer);
        prevBtn.removeEventListener('click', onPrev);
        nextBtn.removeEventListener('click', onNext);
        overlay.style.display = 'none';
      };

      const onPrev = () => {
        if (currentIndex > 0) {
          currentIndex--;
          updateCard();
        }
      };

      const onNext = () => {
        if (currentIndex < cards.length - 1) {
          currentIndex++;
          updateCard();
        }
      };

      prevBtn.addEventListener('click', onPrev);
      nextBtn.addEventListener('click', onNext);

      // Автоматическое завершение и запуск звонка по истечении таймера
      timer = setTimeout(() => {
        cleanup();
        resolve();
      }, delayMs);
    });
  }

  
  async onPhoneClick() {
    if (!this._phoneEnabled) return;

    if (this._phoneClickResolver) {
      this._phoneEnabled = false;
      this._hidePhoneLabel();
      this._phoneClickResolver();
      this._phoneClickResolver = null;
      this._phoneWaitPromise = null;
    }
  }

  async _startFlow() {
    if (this._running) return;
    if (!this._steps?.length) return;

    this._running = true;
    try {
      await this._playStepSequenceFromIndex(0);
    } finally {
      this._running = false;
    }
  }

  async _playStepSequenceFromIndex(startIndex) {
    let idx = startIndex;
    for (; idx < this._steps.length; idx++) {
      await this._execStep(this._steps[idx]);
    }
  }

  async _execStep(step) {
    if (!step) return;

    switch (step.type) {
      case 'audio': {
        await this._executor.playAudio(this._buildMediaUrl(step.urlRel));
        return;
      }

      case 'dossier': {
        await this._showDossierViewer(step.cards || [], step.delayMs || 3000);
        return;
      }

      case 'videos': {
        // Управление видимостью кнопок
        const controls = document.getElementById('video-controls');
        controls.style.display = 'flex';

        await this._executor.playVideos({
          url1: this._buildMediaUrl(step.urlRel1),
          url2: this._buildMediaUrl(step.urlRel2),
          leader: step.leader || 'video1',
          hideControls: false, // Линейные видео оставляем с кнопками
          muteSecond: true     // Мут второго
        });
        controls.style.display = 'none';
        return;
      }

      case 'enablePhone': {
        this._setPhoneEnabled(true, step.labelText || 'сделать звонок');
        return;
      }

      case 'disablePhone': {
        this._phoneEnabled = false;
        this._hidePhoneLabel();
        return;
      }

      case 'waitPhoneClick': {
        await this._waitPhoneClick();
        return;
      }

      case 'showNextButton': {
        const nextBtn = document.getElementById('nextDossierBtn');
        if (nextBtn) {
          nextBtn.style.display = 'block';
          // поддержка текста по шагу (для “Смотреть допросы”)
          if (typeof step.buttonText === 'string' && nextBtn.textContent) {
            nextBtn.textContent = step.buttonText;
          }
        }
        return;
      }

      case 'hideNextButton': {
        const nextBtn = document.getElementById('nextDossierBtn');
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      case 'waitNextButtonClick': {
        await this._waitNextButtonClick();
        return;
      }
      case 'showChoiceButtons': {
        const controls = document.getElementById('controls-scene2');
        if (controls) controls.style.display = 'flex'; // показываем контейнер кнопок
        return;
      }

      case 'hideChoiceButtons': {
        const controls = document.getElementById('controls-scene2');
        if (controls) controls.style.display = 'none';
        return;
      }


      case 'waitFinalChoice': {
        let isWin = false;
        while (!isWin) {
          const choice = await this._waitFinalChoiceClick();

          // Показываем соответствующее видео
          await this._executor.playVideos({
            url1: this._buildMediaUrl(choice.video.m1),
            url2: this._buildMediaUrl(choice.video.m2),
            leader: 'video1'
          });

          if (choice.type === 'win') {
            isWin = true; // Выход из цикла, игра закончена
          } else if (choice.type === 'loseWithHint') {
            // Проигрыш с подсказкой (30.1 или 30.2)
            await this._executor.playAudio(this._buildMediaUrl(choice.hintAudio));
            // После аудио цикл while продолжится автоматически
          }
          // Если просто lose (Иван), цикл просто пойдет на новый круг выбора
        }
        return;
      }


      case 'waitChoiceAndPlay': {
        // 1. Ждем клик, НЕ скрывая кнопки заранее
        const choice = await this._waitChoiceClick();

        // 2. Теперь скрываем кнопки, так как выбор сделан
        const choiceControls = document.getElementById('controls-scene2');
        if (choiceControls) choiceControls.style.display = 'none';

        const urls = choice === 'soft' ? step.soft : step.tense;

        // 3. Управление панелью видео
        const videoControls = document.getElementById('video-controls');
        if (videoControls) {
          videoControls.style.display = step.hideControls ? 'none' : 'flex';
        }

        await this._executor.playVideos({
          url1: this._buildMediaUrl(urls.m1),
          url2: this._buildMediaUrl(urls.m2),
          muteSecond: step.muteSecond
        });

        if (videoControls) videoControls.style.display = 'none';
        return;
      }


      case 'waitAccusation': {
    const overlay = document.getElementById('accusation-overlay');
    if (!overlay) return;

    let isWin = false;

    while (!isWin) {
        overlay.style.display = 'flex';

        const choice = await new Promise((resolve) => {
            const cards = overlay.querySelectorAll('.culprit-card');
            const handler = (e) => {
                const targetId = e.target?.dataset?.id;
                if (!targetId) return;
                cards.forEach(c => c.removeEventListener('click', handler));
                overlay.style.display = 'none';
                resolve(targetId);
            };
            cards.forEach(c => c.addEventListener('click', handler));
        });

        if (choice === 'win') {
            await this._executor.playVideos({
                url1: this._buildMediaUrl('./scene2/29.1. обвинены седа и иван кам 1.mov'),
                url2: this._buildMediaUrl('./scene2/29.1. обвинены седа и иван кам 2.mov'),
                leader: 'video1'
            });
            alert("Поздравляем! Вы раскрыли дело!");
            isWin = true;
        } 
        else if (choice === 'lose') {
            await this._executor.playVideos({
                url1: this._buildMediaUrl('./scene2/29.2 обвинен только иван кам 1.mov'),
                url2: this._buildMediaUrl('./scene2/29.2 обвинен только иван кам 2.mov'),
                leader: 'video1'
            });
            alert("Неверно! Иван не виноват. Попробуйте еще раз.");
        } 
        else if (choice === 'hint_zakhar') {
            await this._executor.playVideos({
                url1: this._buildMediaUrl('./scene2/29.3 обвинен захар кам 1.mov'),
                url2: this._buildMediaUrl('./scene2/29.3 обвинен захар кам 2.mov'),
                leader: 'video1'
            });
            await this._executor.playVideos({
              url1: this._buildMediaUrl('./scene2/30.1. ослаб улик против захара кам 1.mov'),
              url2: this._buildMediaUrl('./scene2/30.1. ослаб улик против захара кам 2.mov'),
              leader: 'video1'
            });
            alert("Захар не виноват. Послушайте подсказку.");
        } 
        else if (choice === 'hint_artemiy') {
            await this._executor.playVideos({
                url1: this._buildMediaUrl('./scene2/29.4 обвинен артемий кам 1.mov'),
                url2: this._buildMediaUrl('./scene2/29.4 обвинен артемий кам 2.mov'),
                leader: 'video1'
            });
            await this._executor.playVideos({
              url1: this._buildMediaUrl('./scene2/30.2. ослаб улик против артемия кам 1.mov'),
              url2: this._buildMediaUrl('./scene2/30.2. ослаб улик против артемия кам 2.mov'),
              leader: 'video1'
            });
            alert("Артемий не виноват. Послушайте подсказку.");
        }
    }
    return;
}

      default:
        return;
    }
  }
  async _waitFinalChoiceClick() {
    const overlay = document.getElementById('final-choice-overlay');
    const buttons = overlay.querySelectorAll('.culprit-btn');
    overlay.style.display = 'flex';

    return new Promise((resolve) => {
      const handler = (e) => {
        const name = e.target.dataset.name;
        overlay.style.display = 'none'; // Скрываем попап

        // Маппинг выбора на логику
        if (name === 'Седа и Иван') {
          resolve({ type: 'win', video: { m1: './scene2/29.1. обвинены седа и иван кам 1.mov', m2: './scene2/29.1. обвинены седа и иван кам 2.mov' } });
        } else if (name === 'Иван') {
          resolve({ type: 'lose', video: { m1: './scene2/29.2 обвинен только иван кам 1.mov', m2: './scene2/29.2 обвинен только иван кам 2.mov' } });
        } else if (name === 'Захар') {
          resolve({ type: 'loseWithHint', video: { m1: './scene2/29.3 обвинен захар кам 1.mov', m2: './scene2/29.3 обвинен захар кам 2.mov' }, hintAudio: './scene2/30.1 подсказка.mp3' });
        } else if (name === 'Артемий') {
          resolve({ type: 'loseWithHint', video: { m1: './scene2/29.4 обвинен артемий кам 1.mov', m2: './scene2/29.4 обвинен артемий кам 2.mov' }, hintAudio: './scene2/30.2 подсказка.mp3' });
        }
      };

      buttons.forEach(btn => btn.addEventListener('click', handler, { once: true }));
    });
  }

  async _waitChoiceClick() {
    const softBtn = document.getElementById('soft'); // Кнопка "Мягкий допрос"
    const tenseBtn = document.getElementById('tense'); // Кнопка "Напряженный допрос"

    // Защита, если элементы не найдены в DOM
    if (!softBtn || !tenseBtn) {
      console.error("Кнопки выбора не найдены в DOM");
      return;
    }

    if (this._choiceWaitPromise) return this._choiceWaitPromise;

    this._choiceWaitPromise = new Promise((resolve) => {
      const onSoft = () => { cleanup(); resolve('soft'); };
      const onTense = () => { cleanup(); resolve('tense'); };

      const cleanup = () => {
        softBtn.removeEventListener('click', onSoft);
        tenseBtn.removeEventListener('click', onTense);
        this._choiceWaitPromise = null;
      };

      softBtn.addEventListener('click', onSoft);
      tenseBtn.addEventListener('click', onTense);
    });

    return this._choiceWaitPromise;
  }


  async _waitPhoneClick() {
    if (this._phoneWaitPromise) return this._phoneWaitPromise;

    this._phoneEnabled = true;
    this._phoneWaitPromise = new Promise((resolve) => {
      this._phoneClickResolver = resolve;
    });

    return this._phoneWaitPromise;
  }

  async _waitNextButtonClick() {
    const btn = document.getElementById('nextDossierBtn');
    if (!btn) return;

    // disable multiple triggers
    if (this._nextBtnWaitPromise) return this._nextBtnWaitPromise;

    this._nextBtnWaitPromise = new Promise((resolve) => {
      const handler = () => {
        btn.removeEventListener('click', handler);
        this._nextBtnWaitPromise = null;
        resolve();
      };
      btn.addEventListener('click', handler, { once: true });
    });

    return this._nextBtnWaitPromise;
  }


  _buildMediaUrl(relPath) {
    const base = (this.audioBaseUrl || './assets').replace(/\/+$/, '');
    const rel = String(relPath).replace(/^\.+\/+/, '').replace(/^\.\//, '');
    return `${base}/${rel}`;
  }

  async destroy() {
    this._running = false;
    this._phoneEnabled = false;
    this._hidePhoneLabel();

    if (this._phoneClickResolver) {
      this._phoneClickResolver();
      this._phoneClickResolver = null;
    }
  }
}

